/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

@endpoint('configDc')
export default class ConfigurationModel extends BaseModel {
  /**
   * Properties.
   */
  distributionCenterRadius?: number;

  /**
   * Constructor.
   */
  constructor(data?: Partial<ConfigurationModel>) {
    super(data);
  }
}
